import useAccountInfo from "@/hooks/useAccountInfo";
import { useClientFeature } from "@/hooks/useClientFeature";
import { canUseAiChat } from "./aiChatAccess";

/**
 * Not the real check — `/ai/chat/*` enforces the tenant flag in middleware and
 * the role in each handler — this only removes the affordance and stops a
 * request that would 403.
 */
export function useHasAiChatAccess(): boolean {
  const accountInfo = useAccountInfo((state) => state.accountInfo);
  const { isFeatureEnabled } = useClientFeature();

  return canUseAiChat(accountInfo, isFeatureEnabled("limeAiChat"));
}
